import { render, staticRenderFns } from "./ChatterList.vue?vue&type=template&id=0340c1ea&scoped=true"
import script from "./ChatterList.vue?vue&type=script&lang=js"
export * from "./ChatterList.vue?vue&type=script&lang=js"
import style0 from "./ChatterList.vue?vue&type=style&index=0&id=0340c1ea&prod&lang=css"
import style1 from "./ChatterList.vue?vue&type=style&index=1&id=0340c1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0340c1ea",
  null
  
)

export default component.exports